import React from "react";
import { Helmet } from "react-helmet";

export default function Contact(): any {
  return (
    <React.Fragment>
      <Helmet>
        <title>Mantz Vac Center - Contact</title>
      </Helmet>
      <div className="customBgPages">
        <div className="container">
          <div className="customHorizontalLine"></div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="customPageInfo">
                <h1>
                  <a href="tel:9204525535">(920) 452-5535</a>
                </h1>
                <p>1320 Michigan Avenue</p>
                <p>Sheboygan, WI 53081</p>
                <h1>Store Hours</h1>
                <table style={{ marginLeft: "10px" }}>
                  <tr>
                    <td className="tdLeft">Monday – Thursday:&nbsp;</td>
                    <td className="tdRight">
                      9:00AM - 1:30PM, 2:00PM - 5:00PM
                    </td>
                  </tr>
                  <tr>
                    <td className="tdLeft">Friday:&nbsp;</td>
                    <td className="tdRight">9:00AM - 1:30PM</td>
                  </tr>
                  <tr>
                    <td className="tdLeft">Saturday:&nbsp;</td>
                    <td className="tdRight">9:00AM – 11:00AM</td>
                  </tr>
                  <tr>
                    <td className="tdLeft">Sunday:&nbsp;</td>
                    <td className="tdRight">Closed</td>
                  </tr>
                </table>
                <h1>
                  <a
                    href="mailto:info@mantzvac.com?Subject=Website%20Email"
                    target="_top"
                  >
                    info@mantzvac.com
                  </a>
                </h1>
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <img className="aboutBg" src="/mv_map.jpg" />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
